import { get } from '../api/api';
import { ENDPOINT_MICROSERVICE } from '../api/payments';

export const getIpInfo = async (): Promise<{
  country: string;
  countryCode: string;
}> => {
  let country: string;
  let countryCode: string;

  try {
    const ipInfoData = await get({
      endpoint: ENDPOINT_MICROSERVICE,
      path: 'ip_api',
    });
    country = ipInfoData.country;
    countryCode = ipInfoData.countryCode;
  } catch (error) {
    country = 'US';
    countryCode = 'US';
    console.warn('Failed to fetch IP info', error);
  }

  return { country, countryCode };
};
